module.exports = __webpack_public_path__ + "img/door-opened.6d71d3c8.svg";